import Box from "@mui/material/Box";
import React from "react";

const Separator = () => {
  return <Box sx={{ height: { xs: 24, lg: 64 } }} />;
};

export default Separator;
